import clsx from 'clsx'
import styles from './customers-marquee.css?url'
import { CustomerLogos } from '~/config/customers'
import { LinksFunction } from 'react-router'

export const customersMarqueeLinks: LinksFunction = () => [
  { rel: 'stylesheet', href: styles },
]

export const CustomersMarquee = ({
  classNames,
  LogosToUse = CustomerLogos,
  mobileGrid = true,
  hideMobileGridTitle = false,
  title = 'Trusted by',
}: {
  classNames?: string
  LogosToUse?: typeof CustomerLogos
  mobileGrid?: boolean
  hideMobileGridTitle?: boolean
  title?: string
}) => {
  return (
    <section
      className={clsx(
        'marquee',
        'full-width',
        mobileGrid ? 'is-mobile-grid' : '',
        classNames,
      )}
    >
      {!hideMobileGridTitle && (
        <hgroup className="centered-section-title">
          <h3>{title}</h3>
        </hgroup>
      )}
      <div className="marquee--inner">
        <div className="marquee--content">
          {LogosToUse.map((customer) => {
            return (
              <div className="marquee--logo-mobile-wrapper" key={customer.name}>
                <div
                  className={clsx([
                    'logo-image',
                    customer.name &&
                      customer.name.toLowerCase().replace(/\s+/g, '-'),
                  ])}
                >
                  <img
                    src={`/images/customer-logos/${customer.image}`}
                    alt={customer.name}
                    decoding="async"
                  />
                </div>
              </div>
            )
          })}
        </div>

        <div
          className={`marquee--content ${mobileGrid && 'hide-for-mobile'}`}
          aria-hidden="true"
        >
          {LogosToUse.map((customer) => {
            return (
              <div className="marquee--logo-mobile-wrapper" key={customer.name}>
                <div
                  className={clsx([
                    'logo-image',
                    customer.name &&
                      customer.name.toLowerCase().replace(/\s+/g, '-'),
                  ])}
                >
                  <img
                    src={`/images/customer-logos/${customer.image}`}
                    alt=""
                    decoding="async"
                  />
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </section>
  )
}
